import { ArrowRight, BarChart3, FileSpreadsheet, FolderKanban, Inbox, KanbanSquare, Megaphone, Settings2 } from "lucide-react";
import { useCallback, useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";

import { api } from "@/api";
import { useAuth } from "@/auth";
import { HotDeals, Kpis, ObjectiveGauge, RevenueCurve, StageBar } from "@/components/home/HomeWidgets";
import { canSee } from "@/permissions";
import "@/home.css";
import { enterPage } from "@/themes/rapport/motion";

const AREAS = [
  { to: "/reponses", icon: Inbox, title: "Réponses", text: "Les e-mails reçus à traiter, classés par l'IA." },
  { to: "/pipeline", icon: KanbanSquare, title: "Pipeline", text: "Toutes vos opportunités noCRM en colonnes ou en liste." },
  { to: "/projets", icon: FolderKanban, title: "Projets", text: "Discussions, to-do, Kanban et documents partagés." },
  { to: "/devis/validation", icon: Megaphone, title: "Marketing", text: "Devis, parcours de relance et file d'envoi." },
  { to: "/recyclage", icon: FileSpreadsheet, title: "Fichiers de prospection", text: "Préparer ou recycler des fichiers prospects." },
  { to: "/statistiques-agents", icon: BarChart3, title: "Statistiques", text: "La production de chaque agent par pipeline et tag." },
  { to: "/parametres", icon: Settings2, title: "Paramètres", text: "Connexions noCRM, Gmail et réglages des devis." },
];

export default function HomePage() {
  const { user } = useAuth();
  const [d, setD] = useState(null);
  const [archived, setArchived] = useState(false);
  const load = useCallback(() => api.get("/home/dashboard", { params: archived ? { archived: true } : {} }).then(({ data }) => setD(data)).catch(() => setD(false)), [archived]);
  useEffect(() => { if (canSee(user, "/pipeline")) load(); else setD(false); }, [load, user]);
  const ref = useRef(null);
  const ready = d !== null;
  useEffect(() => (ready ? enterPage(ref.current) : undefined), [ready]);
  return (
    <section className="page home-page hm-page" ref={ref} data-testid="home-page">
      <header className="head hm-head">
        <h1 className="head__title" data-rise="" data-testid="home-title">Vue d'ensemble</h1>
        {d && <Kpis d={d} />}
        {d && <label className="hm-archived" data-testid="home-archived-label"><input type="checkbox" checked={archived} onChange={(e) => setArchived(e.target.checked)} data-testid="home-archived-toggle" /> Inclure les pipelines archivés</label>}
      </header>
      {d === null && <p className="ck-muted">Chargement du tableau de bord…</p>}
      {d && (
        <>
          <RevenueCurve d={d} />
          <ObjectiveGauge objective={d.objective} canEdit={d.can_edit_objective} onSaved={load} />
          <HotDeals deals={d.hot} today={d.today} />
          <StageBar stages={d.stages} scope={d.scope} open={d.open.count} />
        </>
      )}
      <section className="card hm-card hm-areas" data-land="">
        <header><h3>Vos rubriques</h3></header>
        <div className="home-grid">
          {AREAS.filter((a) => canSee(user, a.to)).map(({ to, icon: Icon, title, text }) => (
            <Link key={to} to={to} className="home-card" data-testid={`home-card-${to.replace(/\W+/g, "-")}`}>
              <span className="home-card-icon"><Icon size={18} /></span>
              <strong>{title}</strong>
              <p>{text}</p>
              <span className="home-card-go">Ouvrir <ArrowRight size={14} /></span>
            </Link>
          ))}
        </div>
      </section>
    </section>
  );
}
